import { Grid, } from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import { Services as sdkServices } from "coolremote-sdk";
import { Field, Formik } from "formik";
import React, { useState } from "react";
import { Redirect } from "react-router";
import { t } from "ttag";
import * as Yup from "yup";
import ErrorBox from "../../components/ErrorBox/ErrorBox";
import CButton from "../../cool_widgets/Button";
import assetsService from "../../services/assetsService";
import useStyles from "./ForgotPassword.style";
import InputField from "./InputField";

interface ILoginState {
  email: string;
}
const ForgotPasswordSchema = Yup.object({
  email: Yup.string().matches(
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    t`Invalid email`
  )
});

const ForgotPassword: React.FC<any> = () => {
  const classes = useStyles();
  const [isPasswordSet, setIsPasswordSet] = useState(false);
  const [isLoginBack, setIsLoginBack] = useState(false);
  const initialValues: ILoginState = {
    email: ""
  };
  const [error, setError] = useState<any>(null);
  const errorBox = error ? (
    <ErrorBox error={error} onClose={() => setError(null)} />
  ) : null;

  const handleBack = () => {
    setIsLoginBack(true);
  };

  const handleSetPassword = (values: ILoginState) => {
    if (values.email) {
      const payload: any = { email: values.email };

      sdkServices.forgotPassword(payload)
        .then((data: any) => {
          if (data)
            setIsPasswordSet(true);
          setError("User is not found");
        })
        .catch((err: any) => {
          setError(err.message);
        });
    }
  };

  if (isLoginBack) {
    return <Redirect to={"/"} />;
  }
  if (isPasswordSet) {
    return <Redirect to={"/reset-password"} />;
  }
  return (
    <div className={classes.Login}>
      <div className={classes.main}>
        <div className={classes.logos}>
          <img
            alt="logo"
            src={assetsService.getResourcePath("BlackLogo.png")}
            className={classes.logo}
          />
        </div>

        <div className={classes.interactionSection}>
          <div className={classes.content}>
            <Typography className={classes.titleStyle}>{t`Password Recovery`}</Typography>
            <Typography className={classes.recoverPasswordMessegeStyle}>
              {t`No worries, we'll help you get back to work.
            Verify your username and account email address to continue.`}
            </Typography>
            <Formik
              initialValues={initialValues}
              onSubmit={handleSetPassword}
              enableReinitialize={true}
              validationSchema={ForgotPasswordSchema}
              validateOnChange={false}
              validateOnBlur={false}
            >
              {({
                handleSubmit,
                errors,
                touched,
                values
              }) => (
                <form style={{ width: "100%" }} onSubmit={handleSubmit}>
                  <Grid container className={classes.container}>
                    <Grid item className={classes.fieldContainer}>
                      <Field
                        classes={{ root: classes.overrideField }}
                        label={t`Your username/email`}
                        value={values.email}
                        name="email"
                        component={InputField}
                        error={errors.email && touched.email}
                        helperText={errors.email && touched.email && errors.email}
                      />
                    </Grid>
                    {errorBox}
                    <Grid item className={classes.buttonContainer}>
                      <CButton
                        disableTouchRipple
                        disableFocusRipple
                        title={t`Back to Login`}
                        className={classes.button}
                        onClick={handleBack}
                      >
                        {t`Back to Login`}
                      </CButton>
                      <CButton
                        title={t`Reset Password`}
                        className={classes.button}
                        type="submit"
                        red
                        onMouseUp={handleSubmit}
                      >
                        {t`Reset Password`}
                      </CButton>
                    </Grid>
                  </Grid>
                </form>
              )}
            </Formik>
            <Typography className={classes.bottom}>
              {t`Forgot your username or email?`}
              <br />
              {t`Please contact `}
              <a className={classes.mailto} target="_blank" href="mailto:support@coolremote.com">
                support@coolremote.com
              </a>
            </Typography>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
